<template>
  <div>
    <b-modal
      size="lg"
      id="createMedicine"
      title="NOVO MEDICAMENTO"
      hide-footer
      no-close-on-backdrop
    >
      <NewMedicine @success="get" :resident_id="resident_id" />
    </b-modal>
    <b-modal
      size="lg"
      id="inputMedicine"
      title="ENTRADA DE MEDICAMENTO"
      hide-footer
      no-close-on-backdrop
    >
      <InputMedicine
        @success="get"
        :resident_id="resident_id"
        :medicine="medicine"
      />
    </b-modal>
    <b-modal
      size="lg"
      id="transferMedicine"
      title="TRANSFERÊNCIA DE MEDICAMENTO"
      hide-footer
      no-close-on-backdrop
    >
      <TransferMedicine
        @success="get"
        :resident_id="resident_id"
        :medicine="medicine"
      />
    </b-modal>
    <div class="row">
      <div class="col-md-12 pt-0 pb-0">
        <ErrorsMessages :errors="errors" />
      </div>
      <div class="col-md-12 text-right">
        <v-btn
          v-if="permission('read', 'resident_stock_entry')"
          @click="$bvModal.show('createMedicine')"
          class="btn-two-add"
        >
          <i class="fas fa-plus mr-2 text-twenty"></i>ADICIONAR NOVO MEDICAMENTO
        </v-btn>
      </div>
    </div>
    <b-overlay :show="loading" opacity="0.99">
      <div
        class="row mb-4"
        v-if="
          stock.prescribed_medicines_in_stock &&
          stock.prescribed_medicines_in_stock.length == 0 &&
          stock.prescribed_medicines_without_stock &&
          stock.prescribed_medicines_without_stock.length == 0 &&
          stock.future_prescription_medicines_without_stock &&
          stock.future_prescription_medicines_without_stock.length == 0 &&
          stock.medicines_not_prescribed_in_the_current_prescription_with_stock &&
          stock.medicines_not_prescribed_in_the_current_prescription_with_stock
            .length == 0
        "
      >
        <div class="col-md-12 w-sidebar-body">
          <h4 class="subtitles mt-2 check-text-center">
            RESIDENTE NÃO POSSUI MEDICAMENTO(S) NO ESTOQUE.
          </h4>
        </div>
      </div>
      <!-- MEDICAMENTO (S) PRESCRITO (S) COM ESTOQUE. -->
      <div
        class="card mb-4"
        v-if="
          stock.prescribed_medicines_in_stock &&
          stock.prescribed_medicines_in_stock.length > 0
        "
      >
        <div class="col-md-12 a-sidebar-body">
          <h4 class="subtitles mt-2 check-text-center">
            MEDICAMENTO (S) PRESCRITO (S) COM ESTOQUE.
          </h4>
        </div>
        <div class="col-md-12">
          <b-overlay :show="loading" opacity="0.99">
            <div
              v-for="(medicine, key) in stock.prescribed_medicines_in_stock"
              :key="key"
              class="border-bottom"
            >
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pt-0">
                  <h6 class="mb-0 check-text-center">
                    {{ medicine.name }}
                  </h6>
                  <p class="legends worksansr mb-1 check-text-center">
                    {{ medicine.active_ingredient }}
                  </p>
                  <p
                    class="badge bg-warning m-0"
                    v-if="
                      medicine.group_prescription_medicine_type == 'LONGO_PRAZO'
                    "
                  >
                    MEDICAMENTO DE PRESCRIÇÃO DE LONGO PRAZO!
                  </p>
                  <div class="d-flex residenttop-content">
                    <h6
                      class="btn-pendent"
                      v-if="
                        medicine.type_of_recipe_name ==
                        'CONTROLE ESPECIAL - 2 VIAS'
                      "
                    >
                      CONTROLE ESPECIAL
                    </h6>
                  </div>
                  <h6
                    class="legends worksansr mb-1 check-text-center"
                    v-if="medicine.list"
                  >
                    LISTA:
                    {{ medicine.list }}
                  </h6>
                  <h6
                    class="legends worksansr mb-0 check-text-center"
                    v-for="stocked_item in medicine.stocked_item"
                    :key="stocked_item.id"
                  >
                    QUANTIDADE EM ESTOQUE:
                    <strong
                      v-if="
                        medicine.unit_of_measurement_value == 'COMPRIMIDO' &&
                        medicine.quantity == '0.33' &&
                        String(stocked_item.total).indexOf('.67') > -1
                      "
                    >
                      {{
                        String(stocked_item.total).substring(
                          0,
                          String(stocked_item.total).length - 3
                        )
                      }}
                      <sup>2/3</sup>
                      {{ medicine.unit_of_measurement_abbreviation }}
                    </strong>
                    <strong
                      v-else-if="
                        medicine.unit_of_measurement_value == 'COMPRIMIDO' &&
                        medicine.quantity == '0.33' &&
                        String(stocked_item.total).indexOf('.34') > -1
                      "
                    >
                      {{
                        String(stocked_item.total).substring(
                          0,
                          String(stocked_item.total).length - 3
                        )
                      }}
                      <sup>1/3</sup>
                      {{ medicine.unit_of_measurement_abbreviation }}
                    </strong>
                    <strong v-else>
                      {{ stocked_item.total }}
                      {{ medicine.unit_of_measurement_abbreviation }}
                    </strong>
                    - {{ stocked_item.stock_group_name }}
                    <div
                      v-if="
                        stocked_item.defeated &&
                        stocked_item.defeated.total &&
                        stocked_item.defeated.total > 0
                      "
                      class="c-danger mt-2"
                    >
                      <strong>
                        EXISTE {{ stocked_item.defeated.total }}
                        {{ medicine.unit_of_measurement_abbreviation }}
                        VENCIDO(S)
                      </strong>
                      <v-btn
                        class="btn-add-down"
                        x-small
                        @click="handleToLot(medicine)"
                      >
                        <i class="fas fa-link mr-1"></i> ACESSAR LOTE</v-btn
                      >
                    </div>
                  </h6>
                  <hr />
                  <Information :item="medicine" />
                </div>
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-end"
                >
                  <v-btn
                    v-if="permission('read', 'resident_stock_transfer')"
                    outlined
                    small
                    class="btn-dateils"
                    @click="transferMedicine(medicine)"
                  >
                    <i class="fas fa-exchange-alt mr-2 text-twenty"></i>
                    TRANSFERIR MEDICAMENTO</v-btn
                  >
                  <v-btn
                    v-if="permission('read', 'resident_stock_entry')"
                    outlined
                    small
                    class="btn-add"
                    @click="inputMedicine(medicine)"
                  >
                    <i class="fas fa-plus mr-2 text-twenty"></i>
                    ADICIONAR</v-btn
                  >
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
      <!-- MEDICAMENTO (S) PRESCRITO (S) SEM ESTOQUE. -->
      <div
        class="card mb-4"
        v-if="
          stock.prescribed_medicines_without_stock &&
          stock.prescribed_medicines_without_stock.length > 0
        "
      >
        <div class="col-md-12 w-sidebar-body">
          <h4 class="subtitles mt-2 check-text-center">
            MEDICAMENTO (S) PRESCRITO (S) SEM ESTOQUE.
          </h4>
        </div>
        <div class="col-md-12">
          <b-overlay :show="loading" opacity="0.99">
            <div
              v-for="(
                medicine, key
              ) in stock.prescribed_medicines_without_stock"
              :key="key"
              class="border-bottom"
            >
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pt-0">
                  <h6 class="mb-0 check-text-center">
                    {{ medicine.name }}
                  </h6>
                  <p class="legends worksansr mb-1 check-text-center">
                    {{ medicine.active_ingredient }}
                  </p>
                  <p
                    class="badge bg-warning m-0"
                    v-if="
                      medicine.group_prescription_medicine_type == 'LONGO_PRAZO'
                    "
                  >
                    MEDICAMENTO DE PRESCRIÇÃO DE LONGO PRAZO!
                  </p>
                  <div class="d-flex residenttop-content">
                    <h6
                      class="btn-pendent"
                      v-if="
                        medicine.type_of_recipe_name ==
                        'CONTROLE ESPECIAL - 2 VIAS'
                      "
                    >
                      CONTROLE ESPECIAL
                    </h6>
                  </div>
                  <h6
                    class="legends worksansr mb-1 check-text-center"
                    v-if="medicine.list"
                  >
                    LISTA:
                    {{ medicine.list }}
                  </h6>
                </div>
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-end"
                >
                  <v-btn
                    v-if="permission('read', 'resident_stock_entry')"
                    outlined
                    small
                    class="btn-add"
                    @click="inputMedicine(medicine)"
                  >
                    <i class="fa-small fas fa-plus mr-2 text-twenty"></i>
                    ADICIONAR</v-btn
                  >
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
      <!-- MEDICAMENTO (S) DE PRESCRIÇÃO (ÕES) FUTURA (S) SEM ESTOQUE. -->
      <div
        class="card mb-4"
        v-if="
          stock.future_prescription_medicines_without_stock &&
          stock.future_prescription_medicines_without_stock.length > 0
        "
      >
        <div class="col-md-12 w-sidebar-body">
          <h4 class="subtitles mt-2 check-text-center">
            MEDICAMENTO (S) DE PRESCRIÇÃO (ÕES) FUTURA (S) SEM ESTOQUE.
          </h4>
        </div>
        <div class="col-md-12">
          <b-overlay :show="loading" opacity="0.99">
            <div
              v-for="(
                medicine, key
              ) in stock.future_prescription_medicines_without_stock"
              :key="key"
              class="border-bottom"
            >
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pt-0">
                  <h6 class="mb-0 check-text-center">
                    {{ medicine.name }}
                  </h6>
                  <p class="legends worksansr mb-1 check-text-center">
                    {{ medicine.active_ingredient }}
                  </p>
                  <p
                    class="badge bg-warning m-0"
                    v-if="
                      medicine.group_prescription_medicine_type == 'LONGO_PRAZO'
                    "
                  >
                    MEDICAMENTO DE PRESCRIÇÃO DE LONGO PRAZO!
                  </p>
                  <div class="d-flex residenttop-content">
                    <h6
                      class="btn-pendent"
                      v-if="
                        medicine.type_of_recipe_name ==
                        'CONTROLE ESPECIAL - 2 VIAS'
                      "
                    >
                      CONTROLE ESPECIAL
                    </h6>
                  </div>
                  <h6
                    class="legends worksansr mb-1 check-text-center"
                    v-if="medicine.list"
                  >
                    LISTA:
                    {{ medicine.list }}
                  </h6>
                </div>
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-end"
                >
                  <v-btn
                    v-if="permission('read', 'resident_stock_entry')"
                    outlined
                    small
                    class="btn-add"
                    @click="inputMedicine(medicine)"
                  >
                    <i class="fas fa-plus mr-2 text-twenty"></i>
                    ADICIONAR</v-btn
                  >
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
      <!-- MEDICAMENTO (S) NÃO PRESCRITO (S) NA PRESCRIÇÃO ATUAL COM ESTOQUE. -->
      <div
        class="card mb-4"
        v-if="
          stock.medicines_not_prescribed_in_the_current_prescription_with_stock &&
          stock.medicines_not_prescribed_in_the_current_prescription_with_stock
            .length > 0
        "
      >
        <div class="col-md-12 d-sidebar-body">
          <h4 class="subtitles mt-2 check-text-center">
            MEDICAMENTO (S) NÃO PRESCRITO (S) NA PRESCRIÇÃO ATUAL COM ESTOQUE.
          </h4>
        </div>
        <div class="col-md-12">
          <b-overlay :show="loading" opacity="0.99">
            <div
              v-for="(
                medicine, key
              ) in stock.medicines_not_prescribed_in_the_current_prescription_with_stock"
              :key="key"
              class="border-bottom"
            >
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pt-0">
                  <h6 class="mb-0 check-text-center">
                    {{ medicine.name }}
                  </h6>
                  <p class="legends worksansr mb-1 check-text-center">
                    {{ medicine.active_ingredient }}
                  </p>
                  <p
                    class="badge bg-warning m-0"
                    v-if="
                      medicine.group_prescription_medicine_type == 'LONGO_PRAZO'
                    "
                  >
                    MEDICAMENTO DE PRESCRIÇÃO DE LONGO PRAZO!
                  </p>
                  <div class="d-flex residenttop-content">
                    <h6
                      class="btn-pendent"
                      v-if="
                        medicine.type_of_recipe_name ==
                        'CONTROLE ESPECIAL - 2 VIAS'
                      "
                    >
                      CONTROLE ESPECIAL
                    </h6>
                  </div>
                  <h6
                    class="legends worksansr mb-1 check-text-center"
                    v-if="medicine.list"
                  >
                    LISTA:
                    {{ medicine.list }}
                  </h6>
                  <h6
                    class="legends worksansr mb-0 check-text-center"
                    v-for="stocked_item in medicine.stocked_item"
                    :key="stocked_item.id"
                  >
                    QUANTIDADE EM ESTOQUE:
                    <strong
                      v-if="
                        medicine.unit_of_measurement_value == 'COMPRIMIDO' &&
                        medicine.quantity == '0.33' &&
                        String(stocked_item.total).indexOf('.67') > -1
                      "
                    >
                      {{
                        String(stocked_item.total).substring(
                          0,
                          String(stocked_item.total).length - 3
                        )
                      }}
                      <sup>2/3</sup>
                      {{ medicine.unit_of_measurement_abbreviation }}
                    </strong>
                    <strong
                      v-else-if="
                        medicine.unit_of_measurement_value == 'COMPRIMIDO' &&
                        medicine.quantity == '0.33' &&
                        String(stocked_item.total).indexOf('.34') > -1
                      "
                    >
                      {{
                        String(stocked_item.total).substring(
                          0,
                          String(stocked_item.total).length - 3
                        )
                      }}
                      <sup>1/3</sup>
                      {{ medicine.unit_of_measurement_abbreviation }}
                    </strong>
                    <strong v-else>
                      {{ stocked_item.total }}
                      {{ medicine.unit_of_measurement_abbreviation }}
                    </strong>
                    - {{ stocked_item.stock_group_name }}
                    <div
                      v-if="
                        stocked_item.defeated &&
                        stocked_item.defeated.total &&
                        stocked_item.defeated.total > 0
                      "
                      class="c-danger mt-2"
                    >
                      <strong>
                        EXISTE {{ stocked_item.defeated.total }}
                        {{ medicine.unit_of_measurement_abbreviation }}
                        VENCIDO(S)
                      </strong>
                      <v-btn
                        class="btn-add-down"
                        x-small
                        @click="handleToLot(medicine)"
                      >
                        <i class="fas fa-link mr-1"></i> ACESSAR LOTE</v-btn
                      >
                    </div>
                  </h6>
                </div>
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-end"
                >
                  <v-btn
                    v-if="permission('read', 'resident_stock_transfer')"
                    outlined
                    small
                    class="btn-dateils"
                    @click="transferMedicine(medicine)"
                  >
                    <i class="fas fa-exchange-alt mr-2 text-twenty"></i>
                    TRANSFERIR MEDICAMENTO</v-btn
                  >
                  <v-btn
                    v-if="permission('read', 'resident_stock_entry')"
                    outlined
                    small
                    class="btn-add"
                    @click="inputMedicine(medicine)"
                  >
                    <i class="fas fa-plus mr-2 text-twenty"></i>
                    ADICIONAR</v-btn
                  >
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import NewMedicine from "./View/new-medicine";
import InputMedicine from "./View/input-medicine";
import TransferMedicine from "./View/transfer-medicine";

import Information from "./View/information";

import permission from "../../../lib/permission";

import api from "../../../services/api";

import routes from "../../../routes";

export default {
  name: "StockView",

  components: {
    ErrorsMessages,
    NewMedicine,
    InputMedicine,
    TransferMedicine,
    Information,
  },

  data() {
    return {
      medicine: null,
      resident_id: null,
      stock: false,
      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    inputMedicine(medicine) {
      this.medicine = medicine;
      this.$bvModal.show("inputMedicine");
    },

    transferMedicine(medicine) {
      this.medicine = medicine;
      this.$bvModal.show("transferMedicine");
    },

    async retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      this.get();
    },

    async get() {
      try {
        this.loading = true;

        let { resident_id } = this;

        let params = { resident_id };

        let response = await api.get("/rest-home/resident/menu-stock", {
          params,
        });

        let { error, errors, data } = response.data;

        if (!error) {
          this.stock = data;
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleToLot(medicine) {
      let { resident_id } = this;
      routes.push({
        name: "new-stock",
        query: {
          menu: "items",
          tipo: "lots",
          s: medicine.name,
          resident_id,
        },
      });
    },
  },
};
</script>
